
import { useMemo } from 'react';
import { ColumnDef } from '@tanstack/react-table';
import OtherIncomeTable from '../commonTables/OtherIncomeTable/OtherIncomeTable';
import TotalPotentialIncomeTable from '../commonTables/TotalPotentialIncomeTable/TotalPotentialIncomeTable';
import IncomeAdjustmentsTable from '../commonTables/IncomeAdjustmentsTable/IncomeAdjustmentsTable';
import GrossRentAdjustmentsTable from '../ApartmentIncome/GrossRentAdjustmentsTable/GrossRentAdjustmentsTable';
import BaseTotalsTable from '../../BaseTotalsTable/BaseTotalsTable';
import { useProFormaSocketContext } from '../../../socketContext/ProFormaSocketProvider';
import BedMixTable from './BedMixTable/BedMixTable';

export interface IStudentHousingIncomeProps {
    operationBeginIndex: number;
    baseCashFlowColumns: ColumnDef<any>[];
}

const StudentHousingIncome = ({
    operationBeginIndex,
    baseCashFlowColumns,
}: IStudentHousingIncomeProps) => {
    const { incomeSummary, operationsCashFlow } = useProFormaSocketContext();

    const grossRentCashFlowValues = useMemo(
        () => operationsCashFlow?.map(cf => cf?.grossRent || 0) || [],
        [operationsCashFlow],
    );

    return (
        <>
            <BedMixTable
                operationBeginIndex={operationBeginIndex}
                baseCashFlowColumns={baseCashFlowColumns}
            />
            <BaseTotalsTable
                tableName="Gross potential rent"
                totalAmount={incomeSummary.grossRent?.totalAmountPerYear || 0}
                cashFlowValues={grossRentCashFlowValues}
                operationBeginIndex={operationBeginIndex}
                baseCashFlowColumns={baseCashFlowColumns}
            />
            <GrossRentAdjustmentsTable
                operationBeginIndex={operationBeginIndex}
                baseCashFlowColumns={baseCashFlowColumns}
            />
            <OtherIncomeTable
                operationBeginIndex={operationBeginIndex}
                baseCashFlowColumns={baseCashFlowColumns}
            />
            <TotalPotentialIncomeTable
                operationBeginIndex={operationBeginIndex}
                baseCashFlowColumns={baseCashFlowColumns}
            />
            <IncomeAdjustmentsTable
                operationBeginIndex={operationBeginIndex}
                baseCashFlowColumns={baseCashFlowColumns}
            />
        </>
    );
};

export default StudentHousingIncome;
